<template>
    <section id="cart">
        <div id="breadcrumbs">
            <div class="bg-light py-3">
                <div class="container">
                    <div class="row">
                        <div class="col">
                            <div class="alert alert-warning">
                                Compras superiores a $599.00 no genera costo de envío (No aplica
                                suscripciones)
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 mb-0 text-left">
                            <router-link to="/">Inicio</router-link>
                            <span class="mx-2 mb-0">/</span>
                            <strong class="text-black">Carrito</strong>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- #breadcrumbs -->
        <div class="site-section">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <form class="form" method="post">
                            <div class="site-blocks-table">
                                <table class="table table-bordered">
                                    <thead class="cart-header">
                                    <tr>
                                        <th class="product-name text-light">Producto</th>
                                        <th class="product-price text-light">Precio</th>
                                        <th class="product-quantity text-light">Cantidad</th>
                                        <th class="product-total text-light">Total</th>
                                        <th class="product-remove text-light">Quitar</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <loading :active.sync="is_loading"></loading>
                                    <tr v-for="product in products">
                                        <td class="product-name">
                                            <h2 class="h5 text-black">{{ product.item_name }}</h2>
                                            <small v-if="product.attribute"
                                            >Color: {{ product.attribute }}</small
                                            >
                                            <div v-if="product.delight">
                                                <ul class="list-group">
                                                    <li class="list-group-item">
                                                        {{ product | delightName }} ({{
                                                            product.quantity
                                                        }})
                                                    </li>
                                                </ul>
                                            </div>
                                        </td>
                                        <td>${{ product.price }}</td>
                                        <td>
                                            <div
                                                class="input-group mb-3 mx-auto"
                                                style="max-width: 120px"
                                            >
                                                <div v-if="product.quantity !== 1" class="input-group-prepend">
                                                    <button
                                                        v-if="product.type_id !== 3 && product.type_id !== 6 && product.type_id !== 7"
                                                        class="btn b-navbar btn-default border-0"
                                                        type="button"
                                                        @click="minus(product)"
                                                    >
                                                        &minus;
                                                    </button>
                                                </div>
                                                <input
                                                    type="text"
                                                    :value="product.quantity"
                                                    class="form-control text-center"
                                                    placeholder=""
                                                    aria-label="Example text with button addon"
                                                    aria-describedby="button-addon1"
                                                    readonly
                                                />
                                                <div class="input-group-append">
                                                    <button
                                                        v-if="product.type_id !== 3 && product.type_id !== 6 && product.type_id !== 7"
                                                        class="btn b-navbar btn-default border-0"
                                                        type="button"
                                                        @click="plus(product)">
                                                        &plus;
                                                    </button>
                                                </div>
                                            </div>
                                        </td>
                                        <td v-if="product.delight">${{ (product.price * product.quantity) + product.delight.prices[0].price }}</td>
                                        <td v-else>${{ product.price * product.quantity }}</td>
                                        <td>
                                            <a
                                                href="#"
                                                class="btn btn-danger btn-sm"
                                                @click="removeProduct(product)"
                                            >X</a
                                            >
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </form>
                    </div>
                    <!-- .col -->
                </div>
                <!-- .row -->
                <div class="row">
                    <div class="col-md-6">
                        <div class="row mb-5">
                            <!-- <div class="col-md-6 mb-3 mb-md-0">
                                              <button class="btn btn-primary btn-sm btn-block" v-on:click="updateCart">Update Cart</button>
                                          </div>-->
                            <div class="col-md-6">
                                <router-link
                                    to="/"
                                    class="btn btn-outline-primary btn-sm btn-block"
                                >Continuar comprando</router-link
                                >
                                <button
                                    v-on:click="vaciarCarrito"
                                    class="btn btn-outline-primary btn-sm btn-block"
                                >
                                    Vaciar Carrito
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 pl-5">
                        <div class="row justify-content-end">
                            <div class="col-md-7">
                                <div class="row">
                                    <div class="col-md-12 text-right border-bottom mb-5">
                                        <h3 class="text-black h4 text-uppercase">
                                            Total del pedido
                                        </h3>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="mb-4">
                                        <small>
                                            Los gastos de envío serán calculados al momento de
                                            finalizar la compra
                                        </small>
                                    </div>
                                </div>
                                <!-- <div class="row mb-3">
                                  <div class="col-md-6">
                                    <span class="text-black">Subtotal</span>
                                  </div>
                                  <div class="col-md-6 text-right">
                                    <strong class="text-black">${{ subtotal }}</strong>
                                  </div>
                                </div> -->
                                <div class="row mb-3" v-if="have_iva">
                                    <div class="col-md-6">
                                        <span class="text-black">IVA</span>
                                    </div>
                                    <div class="col-md-6 text-right">
                                        <strong class="text-black">${{ iva }}</strong>
                                    </div>
                                </div>
                                <!-- <div class="row mb-3" v-if="sent_cost">
                                  <div class="col-md-6">
                                    <span class="text-black">Costo de envío</span>
                                  </div>
                                  <div class="col-md-6 text-right">
                                    <strong class="text-black">$65</strong>
                                  </div>
                                </div> -->
                                <div class="row mb-5">
                                    <div class="col-md-6">
                                        <span class="text-black">Total</span>
                                    </div>
                                    <div class="col-md-6 text-right">
                                        <strong class="text-black">${{ total | pesos }}</strong>
                                    </div>
                                </div>

                                <div class="row">
                                    <div v-if="is_login" class="col-md-12">
                                        <div
                                            class="d-flex align-items-center justify-content-center my-2 pt-2">
                                            <input
                                                @change="checkPolitica"
                                                type="checkbox"
                                                id="politica"
                                                name="politica"
                                                value="politica"
                                            />
                                            <p class="mx-2 my-0 px-0 py-0">
                                                Acepto la
                                                <a target="_blank" href="/terms"
                                                >términos y condiciones</a
                                                >
                                            </p>
                                        </div>
                                        <button
                                            @click="proceedToCheckout"
                                            class="btn btn-success btn-lg py-3 btn-block"
                                            :disabled="!politicaAceptada"
                                            v-if="products.length > 0"
                                        >
                                            Procede al pago
                                        </button>
                                    </div>
                                    <div v-else class="col-md-12">
                                        <button
                                            class="btn btn-success btn-lg py-3 btn-block"
                                            v-if="products.length > 0"
                                            v-b-modal.login-modal
                                        >
                                            Inicia sesión para proceder al pago
                                        </button>
                                        <button
                                            type="button"
                                            class="btn btn-info btn-lg py-3 btn-block"
                                            @click="proceedAsGuest"
                                            v-if="products.length > 0"
                                        >
                                            Continua como Invitado
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- .col -->
                </div>
                <!-- .row -->
            </div>
            <!-- .container -->
        </div>
        <!-- .site-secton -->
    </section>
    <!-- #cart -->
</template>

<!-- <script id="ze-snippet" src="https://static.zdassets.com/ekr/snippet.js?key=c9367b31-7b36-43bb-a8fb-7b1fd90a94bd">
</script> -->

<script>
// @ is an alias to /src
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
const axios = require("axios");

export default {
    name: "cart",
    components: {
        Loading,
    },
    data() {
        return {
            api_url: process.env.VUE_APP_SUSCRIPTIONS_ROUTE,
            base_url: process.env.VUE_APP_SUSCRIPTIONS_BASE_ROUTE,
            products: [],
            subtotal: 0,
            total: 0,
            iva: 0,
            have_iva: false,
            sent_cost: false,
            is_login: false,
            politicaAceptada: false,
            typeUser: null,
            productsServer: [],
            prevRoute: null,
            is_loading: false,
        };
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.prevRoute = from;
        });
    },
    created() {
		// let scriptTag = document.createElement('script');
        // scriptTag.setAttribute('src', 'https://static.zdassets.com/ekr/snippet.js?key=c9367b31-7b36-43bb-a8fb-7b1fd90a94bd');
        // scriptTag.setAttribute('id', 'ze-snippet');
        // document.body.appendChild(scriptTag)


        if ($cookies.isKey("utoken")) {
            this.is_login = true;
            this.typeUser = "El usuario esta registrado";
        } else {
            this.is_login = false;
            this.typeUser = "El usuario es invitado";
        }
    },
    mounted() {
        // Cargando carrito desde el servidor
        if ($cookies.get("uidmmkg")) {
            this.is_loading = true;
            this.addLocalProductsToDataBase();
        }else{
            this.products = this.$store.state.cart;
            this.updateLocalCart();
        }

        window.dataLayer.push({
            event: "visualizacionCarrito",
            pageURL: this.$router.currentRoute.fullPath,
            // product: this.$store.state.cart,
            product: this.products,
            visitorType: this.typeUser,
            dateVisit: new Date().toLocaleString("en-US"),
        });

    },
    methods: {
        getName: function (product) {
            return product.product.name;
        },
        getPrice: function (product) {
            return product.product.prices[0].price;
        },
        checkPolitica: function () {
            this.politicaAceptada = !this.politicaAceptada;
        },
        vaciarCarrito: function () {
            if (this.products.length > 0) {
                this.products.splice(0, this.products.length);
                // Se borra del carrito
                this.$store.commit("updateCart", this.products);
                // Actualizamos el carrito
                // this.updateCart();
                this.updateLocalCart();

                if($cookies.get("uidmmkg")){
                    //Vaciando datos de el carrito de el servidor
                    axios({
                        method: "POST",
                        url: this.api_url + "/cart/empty-cart/" + $cookies.get("uidmmkg"),
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + $cookies.get("ctoken"),
                        },
                    })
                        .then((response) => {
                            if (response.data.status) {
                                console.log(response.data);
                                console.error("vaciando carrito de el servidor");
                            } else {
                                console.log(response.data.message);
                            }
                        })
                        .catch((error) => {
                            console.error(error);
                        });
                    }

                this.$snotify.warning("Se ha vaciado el carrito");
            } else {
                this.$snotify.warning("El carrito está vacio");
            }
        },
        baseUrlImage: function (file) {
            return this.base_url + "/storage/upload/" + file;
        },
        plus: function (product) {
            product.quantity++;
            this.updateCart();
            this.$store.commit("updateCart", this.products);
        },
        minus: function (product) {
            if (product.quantity > 1) {
                console.error("mayor");
                product.quantity--;
                this.updateCart();
                this.$store.commit("updateCart", this.products);
            } else {
                console.error("menor");
                // Se borra del arreglo
                // this.products.splice(this.products.indexOf(product), 1);
                this.removeProduct(product);
                // Se borra del carrito
                this.$store.commit("updateCart", this.products);
                this.updateLocalCart();
                if($cookies.get("uidmmkg")){                    
                    this.$store.commit("finishStore");
                }
                // this.updateCart();
                //this.loadServerCart();
            }
        },
        updateCart: function () {
            var suma = 0;
            var tiene_costo = false;
            this.products.forEach(
                function (item) {

                    if(item.delight){
                        console.log("has delight : ");
                        suma += (item.quantity * item.price) + item.delight.prices[0].price
                        console.info(item);
                        console.log("item:", item.quantity);
                        console.log("item price: ", item.price);
                        console.log("delight price:", item.delight.prices[0].price);
                        console.log("suma: ", suma);
                    }
                    else{
                        console.log("producto normal: ");
                        suma += item.quantity * item.price;
                        console.info(item);
                        console.log("item:", item.quantity);
                        console.log("item price: ", item.price);
                        console.log("suma: ", suma);
                    }

                    console.log("actualizando producto", item);


                    if($cookies.get("uidmmkg")){
                        // actualizando datos a el servidor
                        let paramDelight = null;
                        if(item.delight !== null){
                            paramDelight =  item.delight.id;
                        }
                        axios({
                            method: "POST",
                            url: this.api_url + "/cart/update-item",
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: "Bearer " + $cookies.get("ctoken"),
                            },
                            params: {
                                id: item.id,
                                quantity: item.quantity,
                                user_id: $cookies.get("uidmmkg"),
                                delight_id: paramDelight
                            },
                        })
                            .then((response) => {
                                console.error("actualizando datos en el servidor");
                                if (response.data.status) {
                                    console.log(response.data);
                                } else {
                                    console.log(response.data.message);
                                }
                            })
                            .catch((error) => {
                                console.error(error);
                            });
                        }

                    if (item.type_id === 2 || item.type_id === 3) {
                        tiene_costo = false;
                        // if (item.quantity % 4 === 0) {
                        //   tiene_costo = false;
                        // } else {
                        //   tiene_costo = true;
                        // }
                    } else {
                        tiene_costo = true;
                    }

                    // if (suma >= 599) {
                    //   tiene_costo = false;
                    // }
                }.bind(this)
            );
            this.subtotal = suma;
            if (this.have_iva) {
                this.iva = this.subtotal * 0.16;
                this.total = this.subtotal * 1.16;
            } else {
                this.total = this.subtotal;
            }

            // this.sent_cost = tiene_costo;
            // if (this.sent_cost) {
            //   this.total += 65;
            // }
        },
        updateLocalCart: function(){
            var suma = 0;
            var tiene_costo = false;
            this.products.forEach(
                function (item) {

                    if(item.delight){
                        console.log("has delight : ");
                        suma += (item.quantity * item.price) + item.delight.prices[0].price
                        console.info(item);
                        console.log("item:", item.quantity);
                        console.log("item price: ", item.price);
                        console.log("delight price:", item.delight.prices[0].price);
                        console.log("suma: ", suma);
                    }
                    else{
                        console.log("producto normal: ");
                        suma += item.quantity * item.price;
                        console.info(item);
                        console.log("item:", item.quantity);
                        console.log("item price: ", item.price);
                        console.log("suma: ", suma);
                    }

                    console.log("actualizando producto", item);
                    
                    if (item.type_id === 2 || item.type_id === 3) {
                        tiene_costo = false;
                        // if (item.quantity % 4 === 0) {
                        //   tiene_costo = false;
                        // } else {
                        //   tiene_costo = true;
                        // }
                    } else {
                        tiene_costo = true;
                    }

                    // if(item.delight){
                    //     suma += item.delight.prices[0].price;
                    // }

                    // if (suma >= 599) {
                    //   tiene_costo = false;
                    // }
                }.bind(this)
            );
            this.subtotal = suma;
            if (this.have_iva) {
                this.iva = this.subtotal * 0.16;
                this.total = this.subtotal * 1.16;
            } else {
                this.total = this.subtotal;
            }

            // this.sent_cost = tiene_costo;
            // if (this.sent_cost) {
            //   this.total += 65;
            // }
        },
        removeProduct: function (product) {
            // Se borra del arreglo
            this.products.splice(this.products.indexOf(product), 1);

            if($cookies.get("uidmmkg")){
                //Borrando  el producto de el servidor
                axios({
                    method: "POST",
                    url: this.api_url + "/cart/delete-item",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + $cookies.get("ctoken"),
                    },
                    params: {
                        id: product.id,
                        user_id: $cookies.get("uidmmkg"),
                    },
                })
                .then((response) => {
                    console.info("borrando carrito de el servidor");
                    if (response.data.status) {
                        console.log("respuesta de datos: " + response.data);
                        this.$snotify.info("Se borro correctamente el producto");
                        this.$store.commit("finishStore");
                    } else {
                        console.log(response.data.message);
                        this.$snotify.info("Hubo un error al intentar borrar el producto");
                    }
                    // this.loadServerCart();
                })
                .catch((error) => {
                    console.error(error);
                });   
            }

            // Se borra del carrito
            this.$store.commit("updateCart", this.products);
            // Actualizamos el carrito
            // this.updateCart();
            this.updateLocalCart();
        },
        proceedToCheckout: function () {
            this.$router.push({ name: "checkout", params: { serverCart: this.products }});
        },
        proceedAsGuest: function () {
            console.info("Se procede como invitado");
            this.$router.push({ name: "guestCheckout" });
        },
        addLocalProductsToDataBase(){
            console.info("Agregando productos locales a la BD")
            if(this.$store.state.cart.length > 0){
                var products = this.$store.state.cart;
                console.log("Producto del store a agregar al servidor: ", products);


            let tempProducts = [];

            for (let i = 0; i < products.length; i++) {
                if(products[i].delight){
                    let product = {
                        subscriber_id: $cookies.get("uidmmkg"),
                        product_id: products[i].id,
                        quantity: products[i].quantity,
                        attribute: products[i].attribute,
                        delight_id: products[i].delight.id,
                    }
                    tempProducts.push(product);
                }else{
                    let product = {
                        subscriber_id: $cookies.get("uidmmkg"),
                        product_id: products[i].id,
                        quantity: products[i].quantity,
                        attribute: products[i].attribute,
                        delight_id: null,
                    }
                    tempProducts.push(product);
                }
            }


                axios({
                    method: "POST",
                    url: this.api_url + "/cart/store",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + $cookies.get("ctoken"),
                    },
                    data:{
                        user_id: $cookies.get("uidmmkg"),
                        items: tempProducts
                    }
                })
                    .then((response) => {
                        if(response.data.status){
                            console.log("respuesta de carrito: ", response.data);
                            this.$store.commit("finishStore");
                        }
                        else{
                            console.log(response.data.message);
                        }
                        this.loadServerCart();
                    })
                    .catch((error) => {
                        console.error(error);
                    })
            }else{
                this.loadServerCart();
            }
        },
        loadServerCart: function(){
            if($cookies.get("uidmmkg")){
                axios({
                    method: "GET",
                    url:
                        this.api_url +
                        "/cart/" +
                        $cookies.get("uidmmkg") +
                        "?v=" +
                        Math.floor(Date.now() / 1000),
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + $cookies.get("ctoken"),
                    },
                })
                    .then((response) => {
                        if (response.data.status) {
                            console.log(
                                "cargando carrito de el servidor",
                                response.data.cart
                            );
                            this.productsServer = [];
                            // Se formatea la estructura de los datos similar a el de localStorage
                            for (let i = 0; i < response.data.cart.length; i++) {
                                let data = {
                                    id: response.data.cart[i].product.id,
                                    is_recurrency: false,
                                    attribute: response.data.cart[i].attribute,
                                    delight: response.data.cart[i].delight,
                                    item_description: response.data.cart[i].product.description,
                                    item_name: response.data.cart[i].product.name,
                                    price: response.data.cart[i].product.prices[0].price,
                                    priceObj: response.data.cart[i].product.prices[0],
                                    quantity: response.data.cart[i].quantity,
                                    type_id: response.data.cart[i].product.product_type_id,
                                };
                                this.productsServer.push(data);
                            }

                            if (this.prevRoute.name != "producto") {
                                this.$snotify.info(response.data.message);
                            }
                        } else {
                            console.log(response.data.message);
                        }
                    })
                    .finally(() => {
                        console.log("carrito de el servidor:", this.productsServer);
                        this.products = this.productsServer;
                        // this.updateCart();
                        this.updateLocalCart();
                        this.is_loading = false;
                    })
                    .catch((error) => {
                        console.error(error);
                    });
                }
        }
    },
    filters: {
        pesos: function (number) {
            return new Intl.NumberFormat("es-MX").format(number);
        },
        delightName: function (product) {
            var txtResponse = "";
            if (product.delight) {
                if (product.delight.name == "") {
                    txtResponse = product.delight.description;
                } else {
                    txtResponse = product.delight.name;
                }
            }

            return txtResponse;
        },
    },
};
</script>

<style scoped>
.alert-warning {
    color: #856404 !important;
    background-color: #fff3cd !important;
    border-color: #ffeeba !important;
}
tbody{
    position: relative;
    min-height: 80px;
    width: 100%;
    overflow: hidden;
    margin: auto;
}
.vld-overlay.is-full-page {
    position: absolute;
}
.vld-overlay .vld-background {
    opacity: 1;
}
</style>

<style>
/* tbody{
  position: relative;
  height: 80px;
  width: 100%;
  overflow: hidden;
  margin: auto;
}
.vld-overlay.is-full-page {
    position: absolute;
}
.vld-overlay .vld-background {
    opacity: 1;
} */
</style>
